/**
 * @template T
 * @param {NonNullable<T> | undefined | null} value
 * @param {string} [msg]
 * @returns {T} ...
 */
export function unwrap(value, msg = 'Unwrapped `null` or `undefined`') {
	if (value === undefined || value === null) {
		throw new Error(msg);
	} else {
		return value;
	}
}

/**
 * @template T
 * @template R
 * @param {NonNullable<T> | undefined | null} value
 * @param {(value: T) => R} f
 * @returns {R | undefined | null} ...
 */
export function andThen(value, f) {
	// need to check for null & undef separately cause TS...
	if (value === null) {
		return null;
	}
	if (value === undefined) {
		return undefined;
	}
	return f(value);
}
